import { FC } from 'react';
import { BoxStatusCardData } from '../types/sensors';
import { BoxStatusCard } from '../../../components/box-status-card/BoxStatusCard';

type Props = {
  boxes: BoxStatusCardData[];
  selectedBoxId: number | null;
  onSelect: (box_id: number) => void;
  onClearAlarms: (box_id: number) => void;
};

export const BoxesGrid: FC<Props> = ({ boxes, selectedBoxId, onSelect, onClearAlarms }) => {
  return (
    <div className="row g-3">
      {boxes.map((box) => (
        <div key={box.box_id} className="col-md-6 col-xl-4">
          <BoxStatusCard
            data={box}
            variant="full"
            isSelected={selectedBoxId === box.box_id}
            onClick={() => onSelect(box.box_id)}
            onClearAlarms={() => onClearAlarms(box.box_id)}
          />
        </div>
      ))}
    </div>
  );
};
